import { ITemplateRepository } from '../domain/repositories/ITemplateRepository'
import { Template } from '../domain/entities/Template'

export class GetTemplateDetailUseCase {
  constructor(private templateRepository: ITemplateRepository) {}

  async execute(id: number): Promise<Template> {
    return this.templateRepository.getById(id)
  }
}
